import React from "react";
import { Table, Accordion, Card, Col, Row, Badge, Modal } from "react-bootstrap";
import PersonView from "./PersonView";
import TermRendererLine from "./renderers/TermRendererLine";
import ModalPersonRenderer from "./renderers/ModalPersonRenderer";
import StudentController from "../api/StudentController";
import Loader from "react-loader";

interface PreviousAdvisorsViewState
{
    modalData: Person;
    showModal: boolean;
    advisorsData: Advisor[];
    isLoading: boolean;
    open: boolean;
}

export default class PreviousAdvisorsView extends React.Component<any, PreviousAdvisorsViewState>
{
    studentController: StudentController;

    constructor(props: any)
    {
        super(props);
        this.studentController = new StudentController();

        this.state = {
            modalData: null,
            showModal: false,
            advisorsData: [],
            isLoading: false,
            open: false
        };
    }

    async getPreviousAdvisorsData()
    {
        const previousData = await this.studentController.getPreviousAdvisors();

        if(previousData && previousData.advisors.length > 0)
        {
            this.setState({
                isLoading: false,
                advisorsData: previousData.advisors,
                open: !this.state.open
            });
        }
        else if(previousData === null)
        {
            this.setState({
				isLoading: false, 
                advisorsData: [],
                open: !this.state.open
			});
        }
        else if(previousData.advisors.length === 0)
        {
            this.setState({
				isLoading: false,
                advisorsData: [],
                open: !this.state.open
			});
        }
       
    } 

    componentDidMount()
    {
        this.getPreviousAdvisorsData();
    }

    render(): React.ReactNode
    {
        const handleClose = () => this.setState({ showModal: false });
        const handleShow = (itm: any): void =>
        {
            this.setState({ showModal: true, modalData: itm });
        };

        return <React.Fragment>
            <Accordion defaultActiveKey={"0"}>
                <Card>
                    <Accordion.Toggle href={"javascript:void(0)"} as={"a"} aria-expanded={this.state.open} variant="link" eventKey="0" onClick={() => this.setState({ open: !this.state.open })}>
                        <Card.Header>
                            <Row>
                                <Col xs={10}>
                                    <h2>Previous &nbsp;
                                        {
                                            this.state.advisorsData
                                            &&
                                            <Badge pill style={{ opacity: "0.5" }} variant="secondary">{this.state.advisorsData.length}</Badge>
                                        }
                                    </h2>
                                </Col>
                                <Col xs={1} className="text-right chevron">
                                    <h2><i className={this.state.open ? "far fa-chevron-up" : "far fa-chevron-down"}></i></h2>
                                </Col>
                            </Row>
                        </Card.Header>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="0">
                        <Card.Body>
                            {
                                this.state.isLoading
                                    ?
                                    <div style={{ height: "100px", padding: "50px" }}>
                                        <Loader className={"spinner"} position={"relative"} scale={0.5} radius={15} corners={1} color={"#000"} opacity={0.25} rotate={0} direction={1} speed={1} trail={60} />
                                    </div>
                                    :
                                    <React.Fragment>
                                        <Table responsive className="list">
                                            <thead>
                                                <tr>
                                                    <th>NAME</th>
                                                    <th><i className="fas fa-envelope"></i></th>
                                                    <th>DEPARTMENT</th>
                                                    <th>TYPE</th>
                                                    <th>TERMS</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    (this.state.advisorsData && this.state.advisorsData.length > 0)
                                                        ?
                                                        this.state.advisorsData.map((itm: Advisor, i) =>
                                                        {
                                                            return <tr key={i}>
                                                                <td style={{ width: "250px" }}><a style={{ color: "#1C4B87" }} onClick={(): void => handleShow(itm)}><PersonView data={itm} /></a></td>
                                                                <td className="td-normal"><a href={`mailto:${itm.email}`}><i className="fas fa-envelope"></i></a></td>
                                                                <td className="td-normal">{itm.department ? itm.department : " - "}</td>
                                                                <td className="td-normal">{itm.advisorType ? itm.advisorType : " - "}</td>
                                                                <td style={{ maxWidth: "200px" }} className="td-normal"><TermRendererLine value={itm.terms} /></td>
                                                            </tr>;
                                                        })
                                                        :
                                                        <tr className={"text-center"}>
                                                            <td colSpan={5}>
                                                                <p className="error-text">No Advisors data available</p>
                                                            </td>
                                                        </tr>
                                                }
                                            </tbody>
                                        </Table>
                                        <Modal size={"sm"} centered show={this.state.showModal} onHide={handleClose}>
                                            <Modal.Body>
                                                <ModalPersonRenderer data={this.state.modalData} />
                                            </Modal.Body>
                                        </Modal>
                                    </React.Fragment>
                            }
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
            </Accordion>
        </React.Fragment >;
    }
}